// import axiosInstance, {setBaseURL} from '../axiosInstance';
import apiClient from "./axiosInstanceStock";

// Adding the owner-related function
export const addItemToCart = async (cartData) => {
  try {
    return await apiClient.post("/v1/cartStocks/upsert/", cartData);
  } catch (error) {
    console.log(error);
  }
};
